/**
 * Bootstrap helper for JavaScript.
 *
 * @type {{SCREEN_SM_MIN: number}}
 */
let Bootstrap = {
	/**
	 * Min width size for Small devices.
	 */
	SCREEN_SM_MIN: 768
};

